import { render, staticRenderFns } from "./CancelledAddresses.vue?vue&type=template&id=2c2b9b14&scoped=true&"
import script from "./CancelledAddresses.vue?vue&type=script&lang=js&"
export * from "./CancelledAddresses.vue?vue&type=script&lang=js&"
import style0 from "./CancelledAddresses.vue?vue&type=style&index=0&id=2c2b9b14&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2b9b14",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/project/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSwitch } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VCardText,VContainer,VFlex,VLayout,VSwitch})
